import * as React from "react"

const LogoutSVG = (props) => (
	<svg width={16} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M11 1H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8m4-9-4-4m4 4-4 4m4-4H5"
			stroke="#475163"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default LogoutSVG
